import { render, staticRenderFns } from "./NormalSectionView.vue?vue&type=template&id=5d18d866&"
import script from "./NormalSectionView.vue?vue&type=script&lang=js&"
export * from "./NormalSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports